export function blobToDataUrl(blob: Blob): Promise<string> {
	return new Promise(resolve => {
		const reader = new FileReader();
		reader.readAsDataURL(blob);
		reader.onloadend = () => {
			resolve(reader.result as string);
		};
	});
}
